<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Add language</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  @if (loaded) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" id="form">
      <div class="row">
        <div class="col-12">
          <label class="form-label fw-bold small">Language</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-translate"></i></span>
            <app-dropdown-select formControlName="language">
              @for (language of languages; track language) {
                <app-dropdown-select-option [value]="language">
                  {{ langService.getName(language) }}
                </app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
  <button form="form" type="submit" class="btn btn-primary fw-bold">Add</button>
</div>
